module.exports = __webpack_public_path__ + "static/media/eingangsbereich-sw.dc781007.jpg";